import { useCallback, useSyncExternalStore } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';

// Delt abonnement per bruker: ExpandedOrder rendres per åpnet oppdragskort, og alle skal dele ÉN lytter.
// Klienten bruker dette bare til å skjule/deaktivere; serveren (driverFeeStatus) er fasit ved tildeling.
// Tilstanden leses synkront fra delt cache (useSyncExternalStore), nøkkelet på uid, slik at første
// render aldri viser en gammel brukers eller en optimistisk verdi.
const LOADING = { blocked: false, loading: true };
const NO_USER = { blocked: false, loading: false };
let shared = null; // { uid, state, listeners, unsub }

function subscribe(uid, onChange) {
  if (!shared || shared.uid !== uid) {
    if (shared) shared.unsub();
    const entry = { uid, state: LOADING, listeners: new Set(), unsub: () => {} };
    shared = entry;
    const publish = (state) => {
      entry.state = state;
      entry.listeners.forEach(l => l());
    };
    const q = query(collection(db, 'invoices'), where('driverUid', '==', uid), where('kind', '==', 'tippi-fee'));
    entry.unsub = onSnapshot(q, (snap) => {
      publish({ blocked: snap.docs.some(d => d.data().status === 'overdue'), loading: false });
    }, (err) => {
      console.error('useDriverFeeBlocked:', err);
      publish({ blocked: false, loading: false });
    });
  }
  const entry = shared;
  entry.listeners.add(onChange);
  return () => {
    entry.listeners.delete(onChange);
    if (entry.listeners.size === 0) {
      entry.unsub();
      if (shared === entry) shared = null;
    }
  };
}

function getState(uid) {
  if (!uid) return NO_USER;
  return shared && shared.uid === uid ? shared.state : LOADING;
}

// Kun for tester: river ned delt modul-tilstand så den ikke lekker mellom tester.
export function __resetFeeBlockedForTests() {
  if (shared) shared.unsub();
  shared = null;
}

// {blocked, loading}: blocked er sann bare når sjåføren har et forfalt Tippi-gebyr.
export function useDriverFeeBlocked() {
  const { currentUser } = useAuth();
  const uid = currentUser?.uid;
  const sub = useCallback((onChange) => (uid ? subscribe(uid, onChange) : () => {}), [uid]);
  const get = useCallback(() => getState(uid), [uid]);
  return useSyncExternalStore(sub, get, get);
}
